import { useState, useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"

// @mui material components
import Grid from "@mui/material/Grid"
import Card from "@mui/material/Card"

// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDButton from "components/MDButton"

// Material Dashboard 2 React example components
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout"
import DashboardNavbar from "monitor/Navbars/DashboardNavbar"
import Footer from "monitor/Footer"
import MDInput from "components/MDInput"
import { Link } from "react-router-dom"

import { showToast } from "utils/swalToast"
import { Checkbox, FormControlLabel, TextField } from "@mui/material"
import ModalSelectorMultiple from "components/ModalSelectorMultiple"

// Importa el servicio de fetch para obtener, crear y editar roles
import { fetchPost, fetchRolById, updateRoles, fetchPermisos } from "./service"

function Add() {
  const [rolToEdit, setRolToEdit] = useState(null)
  const navigate = useNavigate()
  const { id } = useParams()
  const [formData, setFormData] = useState({
    nombre: "",
    descripcion: "",
    datosGlobales: "",
    options: [],
    activo: "",
  })
  const [option, setOption] = useState([]) // Stores selected IDs
  const [permisoses, setPermisoses] = useState([])

  useEffect(() => {
    fetchPermisos().then((data) => {
      setPermisoses(data)
    })

    if (id) {
      fetchRolById(id).then((user) => {
        setRolToEdit(user)
        setFormData({
          nombre: user.nombre || "",
          descripcion: user.descripcion || "",
          datosGlobales: user.datosGlobales || "",
          activo: user.activo || "",
          permisoses: user.permisoses,
        })
        setOption(user.permisoses.map((p) => p.idPermiso))
      })
    }
  }, [id])

  const handleChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  const handleChangeSelect = (newValue) => {
    setOption(newValue)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    console.log("valor:" + e.target.datosGlobales.value)
    const data = {
      nombre: e.target.nombre.value,
      descripcion: e.target.descripcion.value,
      datosGlobales: Boolean(formData.datosGlobales),
      activo: Boolean(formData.activo),
      permisoses: permisoses.filter((sucur) => option.includes(sucur.idPermiso)),
    }

    try {
      if (rolToEdit) {
        await updateRoles(id, data)
        showToast({ title: "Rol actualizado exitosamente", icon: "success" })
      } else {
        await fetchPost(data)
        showToast({ title: "Rol agregado exitosamente", icon: "success" })
      }
      setTimeout(() => {
        navigate("/roles")
      }, 2000)
    } catch (error) {
      console.error("Error en la operación:", error)
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={4} mb={4}>
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12} lg={8}>
            <Card>
              <MDBox p={2}>
                <MDTypography variant="h5">{rolToEdit ? "Editar Rol" : "Agregar Rol"}</MDTypography>
              </MDBox>
              <MDBox
                pt={2}
                px={2}
                id="formAddDis"
                onSubmit={handleSubmit}
                component="form"
                role="form"
              >
                <MDBox mb={2}>
                  <MDInput
                    type="text"
                    name="nombre"
                    label="Nombre"
                    fullWidth
                    value={formData.nombre}
                    onChange={handleChange}
                  />
                </MDBox>
                <MDBox mb={2}>
                  <TextField
                    name="descripcion"
                    id="outlined-multiline-static"
                    label="Descripción"
                    multiline
                    rows={4}
                    fullWidth
                    value={formData.descripcion}
                    onChange={handleChange}
                  />
                </MDBox>
                <MDBox mb={2}>
                  <ModalSelectorMultiple
                    value={option || []}
                    onChange={handleChangeSelect}
                    items={permisoses}
                    itemValue="idPermiso"
                    itemLabel="nombre"
                    renderChip={(permiso) => `${permiso.nombre} - ${permiso.accion}`}
                    label="Permisos Asignados"
                    placeholder="Seleccione permisos"
                    searchPlaceholder="Buscar permiso..."
                    emptyText="No se encontraron permisos"
                    fullWidth
                  />
                </MDBox>
                <MDBox mb={2}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="datosGlobales"
                        checked={Boolean(formData.datosGlobales)}
                        onChange={(e) => {
                          const isChecked = e.target.checked
                          console.log(`datosGlobales changed to: ${isChecked}`)
                          setFormData((prev) => ({
                            ...prev,
                            datosGlobales: isChecked,
                          }))
                        }}
                      />
                    }
                    label="SUPERADMIN "
                  />
                </MDBox>
                <MDBox mb={2}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="activo"
                        checked={Boolean(formData.activo)}
                        onChange={(e) =>
                          handleChange({
                            target: { name: "activo", value: e.target.checked },
                          })
                        }
                      />
                    }
                    label="ACTIVO"
                  />
                </MDBox>
                <MDBox mb={2} sx={{ textAlign: "center" }}>
                  <MDButton type="submit" variant="gradient" color="info" sx={{ mr: 1, width: 90 }}>
                    {rolToEdit ? "Actualizar" : "Agregar"}
                  </MDButton>
                  <Link to="/roles">
                    <MDButton
                      type="button"
                      variant="outlined"
                      color="info"
                      sx={{ ml: 1, width: 90 }}
                    >
                      Cancelar
                    </MDButton>
                  </Link>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  )
}

export default Add
